export default "__VITE_ASSET__CYO2dSbi__"